module.exports = __webpack_public_path__ + "static/img/IMG_20240629_122825.582810d2.jpg";